// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "membership_plan".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { membershipPricingTypeValues, membershipValidForValues } from '@borradh-workspace/labels';
/** Response atom for the "membership_plan" table (1:1 with a DB row, on the wire). */
export const membershipPlanAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    sessionCount: z.number().nullable(),
    pricingType: z.enum(membershipPricingTypeValues),
    validFor: z.enum(membershipValidForValues),
    priceCents: z.number(),
    currency: z.string(),
    stripeProductId: z.string().nullable(),
    stripePriceId: z.string().nullable(),
    isActive: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=membershipPlan.js.map